module.exports = __webpack_public_path__ + "img/arrowRight.8360106d.png";